<template>
  <div id="app">
    <router-view/>
    <Alerts></Alerts>
  </div>
</template>

<script>
import Alerts from './components/Alerts'
import { GET_COOKIE, HTTP, HTTP_AUTH, HTTP_COMM } from "@/main";

export default {
  name: 'app',
  data: function() {
    return {
      scrollPage : false
    }
  },
  created : function () {
    if( GET_COOKIE('userToken') ){
      this.$store.state.user.isAuthorized = true;
      HTTP.defaults.headers.common['Authorization'] = 'Token ' + GET_COOKIE('userToken');
      HTTP_AUTH.defaults.headers.common['Authorization'] = 'Token ' + GET_COOKIE('userToken');
      HTTP_COMM.defaults.headers.common['Authorization'] = 'Token ' + GET_COOKIE('userToken');

      if( window.location.search === "" ){
        this.$store.state.initialPage = false;
      }
    }
  },
  methods : {
  },
  components: {
    Alerts
  }
}
</script>


<style src="@/style/main.less" lang="less">
</style>